import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { superAdminRoleStr } from '@piqet-angular/shared';
import { ADMIN_EOL_CONSUMER } from '@piqet-angular/shared';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'piqet-angular-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.css'],
})
export class ActionButtonComponent implements ICellRendererAngularComp {
  params: any;
  currentRoute!: any;
  disableSubmit = false;
  isShowDelete = false;
  isShowEdit = false;
  activeRoute: any;
  reviewName: any;
  endPoint: any;
  isOrigin = true;
  isPallet: boolean = false;
  isPalletConfigGrid: boolean = false;
  isShowDeleteImports: boolean = true;
  isDropdownActive: boolean = false;
  type = 'Packaging project';
  constructor(private route: ActivatedRoute) {
    this.route.url.subscribe((url: any) => (this.currentRoute = url));
    this.activeRoute = this.route.snapshot.routeConfig?.path;
    switch (this.activeRoute) {
      case 'admin-eol-rc':
        this.reviewName = 'Review EOL recycling detail';
        this.endPoint = '/EOL_RC/GetEndofLifeRCForAddUpdate';
        break;
      case 'admin-eol-lf':
        this.reviewName = 'Review EOL landfill detail';
        this.endPoint = '/EOL_LF/GetEndofLifeLFForAddUpdate';
        break;
      case 'admin-eol-cc':
        this.reviewName = 'Review EOL commercial composting detail';
        this.endPoint = '/EOL_CC/GetEndofLifeCCForAddUpdate';
        break;
      case 'admin-eol-hc':
        this.reviewName = 'Review EOL home composting detail';
        this.endPoint = '/EOL_HC/GetEndofLifeHCForAddUpdate';
        break;
      case 'admin-eol-er':
        this.reviewName = 'Review EOL waste energy recovery detail';
        this.endPoint = '/EOL_ER/GetEndofLifeERForAddUpdate';
        break;
      case 'admin-eol-ic':
        this.reviewName = 'Review EOL incineration detail';
        this.endPoint = '/EOL_IC/GetEndofLifeICForAddUpdate';
        break;
      case 'admin-eol-od':
        this.reviewName = 'Review open dump detail';
        this.endPoint = '/EOL_OD/GetEndofLifeODForAddUpdate';
        break;
      case 'admin-eol-sw':
        this.reviewName = 'Review EOL storm water detail';
        this.endPoint = '/EOL_SW/GetEndofLifeSWForAddUpdate';
        break;
      case 'admin-eol-se':
        this.reviewName = 'Review EOL sewer detail';
        this.endPoint = '/EOL_SE/GetEndofLifeSEForAddUpdate';
        break;
      case 'admin-eol-lt':
        this.reviewName = 'Review EOL litter detail';
        this.endPoint = '/EOL_LT/GetEndofLifeLTForAddUpdate';
        break;
      case 'admin-eol-ad':
        this.reviewName = 'Review EOL anerobicdigestion detail';
        this.endPoint = '/EOL_AD/GetEndofLifeADForAddUpdate';
        break;
      case 'admin-eol-rates':
        this.reviewName = 'Review EOL rates detail';
        this.endPoint = '/EOLRates/GetEndofLifeADForAddUpdate';
        break;
      case ADMIN_EOL_CONSUMER:
        this.reviewName = 'Review EOL consumers detail';
        this.endPoint = '/EOLConsumerRates/GetEndofLifeConsumerADForAddUpdate';
        break;
      case 'admin-eol-or':
        this.reviewName = 'Review EOL recycling open loop detail';
        this.endPoint = '/EOL_OR/GetEndofLifeORForAddUpdate';
        break;
      case 'admin-eol-cr':
        this.reviewName = 'Review EOL chemical recycling detail';
        this.endPoint = '/EOL_CR/GetEndofLifeCRForAddUpdate';
        break;
      case 'admin-eol-pg':
        this.reviewName = 'Review EOL pyrolysis/gasification detail';
        this.endPoint = '/EOL_PG/GetEndofLifePGForAddUpdate';
        break;
      case 'admin-eol-ob':
        this.reviewName = 'Review EOL open burning detail';
        this.endPoint = '/EOL_OB/GetEndofLifeOBForAddUpdate';
        break;
      case 'admin-eol-no':
        this.reviewName = 'Review EOL none detail';
        this.endPoint = '/EOL_NO/GetEndofLifeNOForAddUpdate';
        break;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.isOrigin = params.data.isOrigin;
    if (this.params.from == 'dashBord' && params.data.projectType == 'Product project') {
      params.showCopy = false;
    }
    if (params.isPackagingConfig?.toLowerCase() == 'pallet config') {
      if (this.params.data.name?.toLowerCase()?.includes('pallet')) {
        this.params.showDelete = true;
        params.showEdit = true;
      } else {
        this.params.showDelete = true;
        this.params.showEdit = false;
      }
    }
    if (this.params?.value?.toLowerCase() == 'importstatus') {
      if (this.params?.data?.statusName?.toLowerCase() == 'pending') {
        this.isShowDeleteImports = false;
      } else {
        this.isShowDeleteImports = true;
      }
    } else {
      this.isShowDeleteImports = this.params.data?.statusName;
    }

    this.isShowDelete =
      this.params.value == 'organizationMember'
        ? this.params.data?.isActive == 'InActive'
          ? true
          : false
        : false;
    this.disableSubmit = params?.disableSubmit;
    if (
      (this.params.from == 'packagingGrid' || this.params.from == 'dashBord') &&
      this.params.data === this.type
    ) {
      this.isShowDelete = !this.params.data?.canDeleteTeamProject;
      this.isShowEdit = !this.params.data?.canEditTeamProject;
    }
    if (this.params.from == 'adminRoles') {
      if (this.activeRoute == 'admin-roles') {
        this.params.data['isSystem'] =
          this.params.data?.name.toLowerCase() == superAdminRoleStr ? true : false;
      } else {
        this.params.data['isSystem'] =
          this.params.data?.name.toLowerCase() == superAdminRoleStr || !this.params.data?.parentId
            ? true
            : false;
      }
    }
  }

  editProject() {
    this.params?.editData(this.params.data, this.activeRoute, this.endPoint, this.reviewName);
  }

  exportToExcel() {
    this.params?.exportToExcel(this.params.data);
  }

  copyProject() {
    this.params?.copyData(this.params.data, this.activeRoute);
    this.params?.copyDataEditRendarar(this.params.node.data, this.activeRoute);
  }

  showDetails() {
    this.params?.showDetailsData(this.params.data, this.params.value);
  }
  showInvoice() {
    this.params?.invoiceData(this.params.data, this.params.value);
  }
  invoiceDownload() {
    this.params?.invoiceDownloadData(this.params.data, this.params.value);
  }
  viewProject($event: Event) {
    this.params?.viewData(this.params.data, this.activeRoute); //commented as of now but needed to uncomment and put based on condition
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(this.params);
    }
  }

  deleteProject() {
    this.params?.deleteData(this.params.data, this.activeRoute);
  }

  updateBookMark() {
    this.params?.bookMarkComponent(this.params.data);
  }

  hideUnhideFunction() {
    this.params?.hideUnhideFun(this.params.data, this.activeRoute);
  }

  testAutomation() {
    this.params?.testAutomation(this.params.data);
  }

  downloadFile() {
    this.params?.downloadFile(this.params.data);
  }
  reEnqueueFile() {
    this.params?.reEnqueueFile(this.params.data);
  }

  importFile() {
    this.params?.importFile(this.params.data);
  }

  setActiveVersion() {
    this.params?.setActiveData(this.params.data);
  }

  archiveVersion() {
    this.params?.archiveData(this.params.data);
  }

  automationAnalytics() {
    this.params?.automationAnalytics(this.params.data);
  }
}
